export default "0cf8d5fc5fb42501039b3d730d936e59.svg";